/**
 * (c) Copyright Swisscom (Schweiz) AG. All rights reserved.
 *
 * This product is the proprietary and sole property of Swisscom (Schweiz) AG
 * Use, duplication or dissemination is subject to prior written consent of
 * Swisscom (Schweiz) AG.
 *
 * $Id: sitecatalyst.js
 */
$.namespace("SCS.siteCatalyst");

/**
 * NOTE: This file is hosted for web-clipped ECommerce pages
 */

SCS.siteCatalyst.track = function(data) {
	if ($('body').hasClass('cq_isEditMode') || !window.s) {
		return;
	}

	var siteCatalyst = window.s || window.s_one;
	if(data && data.siteCatalystEvent && siteCatalyst && siteCatalyst.t) {
		var pageName = siteCatalyst.pageName;
		var channel = siteCatalyst.channel;
		siteCatalyst.pageName = siteCatalyst.pageName + data.siteCatalystEvent.additionalPageNameExtension;
		siteCatalyst.channel = siteCatalyst.channel + data.siteCatalystEvent.additionalPageNameExtension;
		siteCatalyst.events = data.siteCatalystEvent.events;
		siteCatalyst.products = data.siteCatalystEvent.products;
		for (property in data.siteCatalystEvent.properties) {
			siteCatalyst[property] = data.siteCatalystEvent.properties[property];
		}
		siteCatalyst.t();
		siteCatalyst.pageName = pageName;
		siteCatalyst.channel = channel;
	}
};

//Track link clicks to SiteCatalyst
SCS.siteCatalyst.trackLink = function(data) {
	var siteCatalyst = window.s || window.s_one;

	if(data && data.siteCatalystLink && siteCatalyst && siteCatalyst.tl) {
		siteCatalyst.linkTrackVars = data.siteCatalystLink.linkTrackVars;
		
		// iterate through site catalyst properties and 
		// set them in the s array
		for(property in data.siteCatalystLink.properties) {
			siteCatalyst[property] = data.siteCatalystLink.properties[property];
		}

		// iterate through site catalyst evars and 
		// set them in the s array
		for(eVar in data.siteCatalystLink.eVars) {
			siteCatalyst[eVar] = data.siteCatalystLink[eVar];
		}
	
		// site catalyst link tracking call
		siteCatalyst.tl(this, data.siteCatalystLink.linkType, data.siteCatalystLink.link);
	}
};

SCS.siteCatalyst.addProduct = function(productString) {
	var siteCatalyst = window.s || window.s_one;

	if ($('body').hasClass('cq_isEditMode') || !siteCatalyst) {
		return;
	}	
	if (!SCS.siteCatalyst.isEmpty(siteCatalyst.products)) {
		siteCatalyst.products += ','+productString;
	} else {
		siteCatalyst.products = productString;
	}
};

SCS.siteCatalyst.isEmpty = function(str) {
	return (!str || 0 === str.length);
};



//////////////////
// WEBPACK FOOTER
// ./clientlibs/js/etc/designs/portal/clientlibs/shared/js/sitecatalyst.js
// module id = 81
// module chunks = 0